'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'เลือกเวลา'
};

exports['default'] = locale;